<template>
  <div>
    <a-input-search
      style="margin-bottom: 8px"
      placeholder="请输入搜索内容"
      @change="filterNode"
      allow-clear
    />
    <a-tree
      :expanded-keys="expandedKeys"
      :auto-expand-parent="autoExpandParent"
      :tree-data="deptOptions"
      :replaceFields="replaceFields"
      @select="handleNodeClick"
      @expand="onExpand"
    >
    </a-tree>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { $emit } from '../../../../utils/gogocodeTransfer'

const props = defineProps({
  deptOptions: {
    type: Array,
    required: true,
  },
})

const emit = defineEmits(['select'])

const getParentKey = (id, tree) => {
  let parentKey
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    if (node.children) {
      if (node.children.some((item) => item.id === id)) {
        parentKey = node.id
      } else if (getParentKey(id, node.children)) {
        parentKey = getParentKey(id, node.children)
      }
    }
  }
  return parentKey
}

const replaceFields = {
  children: 'children',
  title: 'label',
  key: 'id',
  value: 'id',
}

const deptNodes = ref([])
const expandedKeys = ref([])
const searchValue = ref('')
const autoExpandParent = ref(true)

const getAllDeptNode = (nodes) => {
  if (!nodes || nodes.length === 0) {
    return []
  }
  nodes.forEach((node) => {
    deptNodes.value.push({ id: node.id, label: node.label })
    return getAllDeptNode(node.children)
  })
}

// 筛选节点
const filterNode = (e) => {
  console.log('筛选节点', e)
  getAllDeptNode(props.deptOptions)
  const value = e.target.value
  console.log('value', value)
  const gData = props.deptOptions
  const keys = deptNodes.value
    .map((item) => {
      if (item.label.indexOf(value) > -1) {
        return getParentKey(item.id, gData)
      }
      return null
    })
    .filter((item, i, self) => item && self.indexOf(item) === i)
  expandedKeys.value = keys
  searchValue.value = value
  autoExpandParent.value = true
  deptNodes.value = []
}

// 节点单击事件
const handleNodeClick = (keys, event) => {
  emit('select', keys[0])
}

const onExpand = (keys) => {
  expandedKeys.value = keys
  autoExpandParent.value = false
}
</script>
